<template>
    <v-content class="fill-height content-background">
        <v-container fluid>
            <router-view></router-view>
        </v-container>
    </v-content>
</template>

<script>
    export default {
        name: "MainContent"
    }
</script>

<style scoped>
    .content-background {
        background-color: #ffffff;
        background: url('~@/assets/clouds-header.jpg') repeat-x top center fixed;
    }
</style>